import { UserManager } from 'oidc-client';
import { TokenService } from "./../core/token.service";
import * as angular from "angular";
import { IWindowService, IDocumentService } from "angular";
import * as $ from "jquery";
import { ServiceControllerStatus } from "../../typings/board/ServiceProcess";

export interface IServiceStatus { state: ServiceControllerStatus, name: string }
export const MONITOR_SERVICE = "monitorService";
type HubProxy = any;

export class MonitorService {
    hub: HubProxy;
    start: JQueryPromise<any>;
    updateServiceStatesCallback: (states: IServiceStatus[]) => void;
    updateSamplesValueCallback: (value: any) => void;


    static $inject = ["$document", "$window", "tokenService", "BoardWebAdminUserManager"];
    constructor($document: IDocumentService, private $window: IWindowService, private tokenService: TokenService, private userManager: UserManager) {
        this.userManager.events.addUserLoaded(user => {
            if (!user) return;
            $.connection.hub.accessToken = user.access_token;
        });
        this.startMonitoring();
    }

    private startMonitoring() {
        // creates a new hub connection
        var processMonitor = ($.connection as any).processMonitorHub;
        this.hub = processMonitor;        

        // add a client-side hub method that the server will call
        processMonitor.client.updateServiceStates = (states: IServiceStatus[]) => {
            if (angular.isDefined(this.updateServiceStatesCallback) && angular.isFunction(this.updateServiceStatesCallback))
                this.updateServiceStatesCallback(states);
        }

        processMonitor.client.updateSamplesValue = samples => {
            if (angular.isDefined(this.updateSamplesValueCallback) && angular.isFunction(this.updateSamplesValueCallback))
                this.updateSamplesValueCallback(samples);
        }
        
        $.connection.hub.logging = process.env.NODE_ENV === "dev";

        this.tokenService.onAdminTokenChange = () => {
            $.connection.hub.accessToken = this.tokenService.boardWebAdminAccessToken;
        }

        $.connection.hub.accessToken = this.tokenService.boardWebAdminAccessToken;
        // start the connection

        this.start = $.connection.hub.start({
            waitForPageLoad: true,
            jsonp: false,
            withCredentials: false,
            transport: [
                "webSockets", // tutti se abilitato su IIS o in self-hosted
                "serverSentEvents", // chrome, Firefox
                "foreverFrame", // iE, Edge
                "longPolling"
            ]
        });

    }
}


// WEBPACK FOOTER //
// ./app/monitor/monitor.service.ts